module.exports = __webpack_public_path__ + "static/img/bulk-delete@2x.3d84acae.png";